<template>
  <div class="">
    <top-header :type="6" :hasBorder="true" :placeholder="'与我签约'" :bgColor="'#fff'" fontSize="0.32rem" />
    <div class="text_con">
      <p class="col_red">* 重要提醒！请务必认真阅读：</p>
      <h3>一、根据徐政办发〔2018〕89号文件精神：</h3>
      <p>1、市区户籍居民家庭拥有一套住房的，商品住房(包括新建商品住房和二手住房，以下同)自权属登记之日起未满2年或新建商品房买卖合同网备时间未满5年的，不得上市交易；</p>
      <p>2、市区户籍居民家庭拥有二套住房及以上、非市区户籍居民家庭拥有一套住房及以上的，商品住房自权属登记之日起未满3年或者新建商品房买卖合同网备时间未满6年的，不得上市交易。</p>
      <p>3、商品住房出售人在出售房屋时应提供不动产登记管理部门出具的《居民家庭住房状况证明》。</p>
      <h3>二、交易提醒及重要告知</h3>
      <p>1、该房屋能否交易需买卖双方预填写合同信息，并上传买卖双方相关材料后，由后台人员审核确认；</p>
      <p>2、本平台内网签的合同未进行交易确认前，本平台仅提供买卖双方网签合同预填写功能，不作为房产交易依据</p>
      <p>3、当前卖方房产发证日期为<span>{{date}} ,发证日期{{text}}</span>，该房屋能否交易需买卖双方预填写合同并上传资料后，由后台人员审核确认能够交易</p>
      <p>4、买卖双方在本平台提交的图片材料需真实有效，在后续线下业务办理中买卖双方需提交在本平台所上传图片资料的原件，因买卖双方提交材料虚假或不真实造成的交易问题或导致交易中止的，由买卖双方自行承担，本平台不承担相应责任</p>
      <div class="pad_b"></div>
      <div class="btn_con">
        <div class="btn" @click="toSign">确定发起交易请求</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  data() {
    return {
      date: null,
      text: ''
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.date = this.formatTime(this.$route.query.date);
    if(!this.$route.query.month) {
      this.text = '字段错误'
    } else if(this.$route.query.month < 24) {
      this.text = '不足2年'
    } else if(this.$route.query.month >= 24 && this.$route.query.month < 36) {
      this.text = '满2年不足3年'
    } else if(this.$route.query.month > 36) {
      this.text = '满3年'
    }
  },
  methods: {
    formatTime(shijianchuo) {
      if(!shijianchuo) {
        return '';
      }
      var time = new Date(shijianchuo * 1);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      return y+'-'+this.add0(m)+'-'+this.add0(d);
    },
    add0(m){
      return m < 10 ? '0' + m : m;
    },
    toSign() {
      this.$http.post('cms/onlineUser/reg/isLogin.do').then(res => {
        if (res.success) {
          this.$http.post('cms/contractData/reg/getOnlineContractDataNew.do', qs.stringify({
            houseListedId: this.$route.query.houseListedId
          })).then(data => {
            if(data.success) {
              this.$router.push({
                path: '/infoCompletion',
                query: {
                  id: data.obj,
                  flag: this.$route.query.flag
                }
              })
            } else {
              this.$dialog.alert({
                title: '提示',
                message: data.msg,
              }).then(() => {
                // on close
              });
            }
          })
        } else {
            this.$toast(res.msg)
          }
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .text_con{
    width: 7.04rem;
    margin: 0 auto;
    padding-top: 0.3rem;
    font-size: 0.3rem;
    .col_red{
      color: #FE0000;
    }
    p{
      margin-bottom: 0.5rem;
      span{
       color: #FE0000;
      }
    }
    h3{
      font-size: 0.32rem;
      font-weight: 800;
      margin-bottom: 0.5rem;
    }
  }
  .pad_b{
    padding-bottom: 1.14rem;
  }
  .btn_con{
    box-shadow: 0 0 0.04rem rgba(0,0,0,0.3);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.2rem 0;
    background-color: #fff;
  }
  .btn{
    width: 7.04rem;
    margin: 0 auto;
    line-height: 0.74rem;
    background-color: #2F72F5;
    color: #fff;
    font-size: 0.28rem;
    font-weight: 800;
    text-align: center;
    border-radius: 0.06rem;
  }
</style>